/**
 * File: LongController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
import textPopup from '../views/editor.html';

class LongController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, $mdMedia, uploadService, $timeout, $sce) {
        //On init function
        this.$onInit = () => {
                $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
                $rootScope.title = "Activity"
                if (!$rootScope.isLoggedIn) {
                    $state.go("login", {}, {
                        reload: true
                    })
                }
            }
            /********** BASIC DETAILS *********/
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/question/"
        let schoolId = localStorageService.get("school_id")
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_LA
        $scope.questionImage = [];
        $scope.descImage = [];
        $scope.explanationImage = [];
        $scope.isLatex = false
        $scope.content_editor_id = userId;
        $scope.isNotComposed = false

        /******* LIMIT FOR QUSTION CREATION *******/
        $scope.option_limit = CQuesConst.OPTION_LIMIT;
        $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
        $scope.questionImage = []
        $scope.valuePoints = []
        $scope.errors = {};
        let editQuestion = $scope.$parent.$parent.editQuestion
        if (editQuestion) {
            $scope._id = editQuestion._id;
            $scope.question = editQuestion.qn_desc           
            $scope.isNotComposed = true
            $scope.question = editQuestion.qn_desc
           $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
            $scope.isLatex = editQuestion.isLatex
            // if(!$scope.isLatex){
            //     $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
            //     $scope.question = $sce.trustAsHtml(editQuestion.qn_desc)  
            // }
            // else{
            //     $scope.used_editor_html = '';
            //     $scope.isNotComposed = true
            // }

            $scope.questionImage = [];
            if (editQuestion.questionImg) {
                if (Array.isArray(editQuestion.questionImg)) {
                    $scope.questionImage = editQuestion.questionImg
                } else {
                    $scope.questionImage.push(editQuestion.questionImg)
                }
            }
            if (editQuestion.value_points) {
                $scope.valuePoints = _.map(editQuestion.value_points, function(point) {
                    point["point"] = point.name
                    point["isEdit"] = false
                    return point;
                })
            }
            $scope.created_dt = editQuestion.created_dt;
            $scope.content_editor_id = editQuestion.content_editor_id;
            $scope.selectedPassage_id = editQuestion.passage_id;
            if ($scope.selectedPassage_id) {
                $scope.selectedPassage = editQuestion.passage_detail;
            }
        
        }
        //TO SET PASSAGE LIST
        var passageCallback = (resultObj) => {
            $scope.isPassagePresent = false;
            $scope.passages = []
            if (resultObj && resultObj.result && resultObj.result.data) {
                var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                if (result) {
                    if (result.length > 0) {
                        $scope.isPassagePresent = true;
                        _.each(result, function (eachPas) {
                            if ($scope.selectedPassage_id === eachPas._id) {
                                eachPas["isSelected"] = true
                            } else {
                                eachPas["isSelected"] = false
                            }
                        })
                        $scope.passages = result
                    }
                    _.defer(() => { $scope.$apply() })
                }
            }
        }
        let authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId,
            user_id: userId
        }
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)

        //Question desc with latex
        var MQ = MathQuill.getInterface(2);
        var mathFieldSpan = document.getElementById('long-math-field');
        mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
        if ($scope.question !== undefined) {
            mathFieldSpan.textContent = $scope.question
        }
        var mathField = MQ.MathField(mathFieldSpan, {
            spaceBehavesLikeTab: false,
            restrictMismatchedBrackets: true,
            handlers: {
                edit: function() {
                    $scope.question = mathField.latex()
                }
            }
        });
        

        //Invokes after the option elements loaded
        $scope.valuePointsInit = function(option) {
            var optionFieldSpan = document.getElementsByClassName('long-valuepoint-edit-field');
            _.each(optionFieldSpan, function(spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.point) {
                    spanElement.textContent = option.point
                }
                var optionField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function() {
                            option.point = optionField.latex()
                        }
                    }
                });
            })
        }

        var mathValuePointFieldSpan = document.getElementById('long-valuepoint-field');
        mathValuePointFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
        if ($scope.valuePoint) {
            mathValuePointFieldSpan.textContent = $scope.valuePoint
        }
        var mathValuePointField = MQ.MathField(mathValuePointFieldSpan, {
            spaceBehavesLikeTab: false,
            restrictMismatchedBrackets: true,
            handlers: {
                edit: function() {
                    $scope.valuePoint = mathValuePointField.latex()
                }
            }
        });

        var formatLatex = function() {
            $timeout(function() {
                var questionElements = document.getElementsByClassName('latex_field')
                _.each(questionElements, function(spanElement) {
                    MQ.StaticMath(spanElement);
                })
            }, 1000);
        }

        $scope.paste = function(e) {
            e.preventDefault();
            return false
        }

        $scope.initformatLatex = function() {
            $timeout(function() {
                var questionElements = document.getElementsByClassName('latex_field')
                _.each(questionElements, function(spanElement) {
                    MQ.StaticMath(spanElement);
                })
            }, 1000);
        }

        $scope.addPoint = function() {
            if ($scope.valuePoint) {
                $scope.errors["value_points"] = ""
                if ($scope.valuePoint.length > CQuesConst.VALUE_POINTS_LIMIT) {
                    $scope.errors["value_points"] = "value point does not exceed " + CQuesConst.VALUE_POINTS_LIMIT
                } else {
                    var point = $scope.valuePoint
                    var mark = $scope.valuepointMark
                    var valuePoint = {
                        point: point,
                        mark: mark,
                        isEdit: false
                    }
                    $scope.valuePoints.push(valuePoint)
                    if ($scope.isLatex)
                        $scope.valuePoint = mathValuePointField.latex("")
                    else
                        $scope.valuePoint = ""
                    $scope.valuepointMark = ""
                }
            } else {
                $scope.errors["value_points"] = "Value point is required"
            }
        }
        $scope.removePoint = function(index) {
            $scope.valuePoints.splice(index, 1)
        }
        $scope.editPoint = function(index) {
            $scope.valuePoints[index].isEdit = true;
        }
        $scope.updatePoint = function(index) {
            var valuePoints = [];
            if ($scope.valuePoints[index].point.length < 0) {
                $scope.errors["value_points." + index + ".point"] = "Value point is required"
            } else if ($scope.valuePoints[index].point.length > CQuesConst.VALUE_POINTS_LIMIT) {
                $scope.errors["value_points." + index + ".point"] = "Value Point does not exceed " + CQuesConst.VALUE_POINTS_LIMIT + " characters";
            } else {
                angular.copy($scope.valuePoints, valuePoints);
                valuePoints[index].isEdit = false;
                angular.copy(valuePoints, $scope.valuePoints)
                formatLatex()
            }
        }

        $scope.cancelDialog = function() {
            $mdDialog.cancel();
            if (imageViewType === 'question')
                $scope.questionImg = $scope.imageArray;
            imageViewType = ""
            $scope.imageArray = []
        };

        //Image upload for question
        $scope.questionImgUpload = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function(fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function(result) {
                        if (result.url) {
                            $scope.questionImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        //DIALOG CONTROLLER FOR IMAGE
        var imageDialogCtrl = function($scope, $mdDialog, imageViewType, imageDetails) {
            $scope.fileUrl = PREVIEW_URL
            $scope.isPassage = false;
            $scope.title = imageDetails.title;
            $scope.imageArray = imageDetails.images;
            $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false

            $scope.deleteImage = function(imageIndex) {
                $scope.imageArray.splice(imageIndex, 1)
            }
            $scope.cancelDialog = function() {
                $mdDialog.cancel();
                if (imageViewType === 'question') {
                    $scope.questionImage = $scope.imageArray
                } else if (imageViewType === 'explan') {
                    $scope.explanationImage = $scope.imageArray
                } else if (imageViewType === 'answer') {
                    $scope.descImage = $scope.imageArray
                }
                $scope.imageArray = []
            };
        }

        var setPassage = () => {            
            $scope.selectedPassage = _.find($scope.passages,function(pas){
                return pas.isSelected
            })
        }
        $scope.cancelSelectedPasssage = function () {

            $scope.selectedPassage = null
            _.each($scope.passages, function (eachPas) {
                eachPas.isSelected=false
            })
          }
        //Open dialog to view image
        $scope.openDialog = (imageType, index, desc) => {
                let imageDetails;
                if (imageType === 'question') {
                    imageDetails = {
                        title: "LA - Question Image",
                        images: $scope.questionImage
                    }
                }
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        imageViewType: imageType,
                        imageDetails: imageDetails
                    },
                    template: imagePopup,
                    controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
            }
            //DIALOG CONTROLLER FOR PASSAGE
        var passageDialogCtrl = function($scope, $mdDialog, passages) {
            $scope.passages = passages
            $scope.fileUrl = PREVIEW_URL
            $scope.isArray = function (obj) {
                return Array.isArray(obj);
            }
            /*
             * Function to cancel dialog to select passage
             */
            $scope.cancelPassage = function () {
                $mdDialog.cancel();
                setPassage()
            };


            
              /*
             * Function to select passage
             */
            $scope.selectPassage = function (passage_id) {
                _.each($scope.passages, function (eachPas) {
                  if (eachPas._id !=passage_id) {
                    eachPas.isSelected = false;
                  }
                })
                $scope.cancelPassage()
              }

        }
        

        

        /*
         * Function to open dialog to select passage
         */
        $scope.openPassage = () => {
            if(!$scope.passages)
            {
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('No Passage')
                    .textContent('Passages not loaded.Try after some time.')
                    .ariaLabel('Passage Dialog')
                    .ok('Ok')
                );
            }
           else
            {
                if($scope.passages.length==0)
               {
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('No Passage')
                    .textContent('No passages added yet. Please add passage and link it')
                    .ariaLabel('Passage Dialog')
                    .ok('Ok')
                );
               }
        
           else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: passagePopup,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
            }
        }
        }
        //Adding OWQ question from UI
        $scope.$on('addLongQuestion', function() {
            $scope.errors = {}
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
            //Validation  
            if ($scope.question == null || $scope.question.trim() == undefined || $scope.question == "") {
                $scope.errors.qn_desc = "Question is required";
                activityErrorCount++;
            } else if ($scope.question.length > $scope.ques_desc_limit) {
                // $scope.errors['qn_desc'] = "Question does not exceed " + $scope.ques_desc_limit + " characters";
                // errCount++;
            }
            if ($scope.valuePoints.length == 0) {
                $scope.errors.value_points = "Atleast One Value point is required";
                activityErrorCount++;
            }
            if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                let obj = {
                        "_id": $scope._id,
                        "question_theme_id": question.theme._id,
                        "question_theme_name": question.theme.name,
                        "strand": question.strand,
                        "tag": question.tag,
                        "wave": question.wave,
                        "qn_desc": '' + $scope.question,
                        "value_points": $scope.valuePoints,
                        "isLatex": $scope.isLatex,
                        "level": question.level,
                        "subject_id": question.subject_id,
                        "school_id": question.school_id,
                        "questionImg": $scope.questionImage,
                        "session_id": question.session_id,
                        "batch_id": question.batch_id,
                        "class_id": question.class_id,
                        "curriculum_id": question.curriculum_id,
                        "xlink": question.link_theme,
                        "cognitive_skills": question.cognitive_skill,
                        "isNotAddToQp": question.isNotAddToQp,
                        "is_traditional_activity": question.is_traditional_activity,
                        "qp_id": question.qp_id,
                        "activity_id": question.activity_id,
                        "user_id": userId,
                        "created_dt": $scope.created_dt,
                        "content_editor_id": $scope.content_editor_id,
                        "passage": $scope.selectedPassage,
                        "teaching_plan_id": question.teaching_plan_id
                }
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                        if (question.is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: question.qp_id
                            })
                            toastr.success("Question Saved successfully");
                        }else if(question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== ""){
                            $state.go('formatQp', {
                                resourceId: question.activity_id
                            })
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession()
                            }
                        }
                    } else {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        toastr.error("Network Error")
                    }
                    _.defer(() => { $scope.$apply() })
                })
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Please fill all mandatory fields")
            }
        })

        //On destroy function
        this.$onDestroy = () => {}
        $scope.viewTextAngular = function () {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
                locals: {
                    parentScope : $scope
                },
                template: textPopup,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
            
        }
        $scope.setQuestionFromEditor = function (editor_value){
            $scope.question = editor_value
            $scope.used_editor = true
            $scope.isNotComposed = true
            let used_editor = document.getElementById('used_editor')
            $scope.used_editor_html = $sce.trustAsHtml(editor_value);
            // used_editor.append(editor_value)
            console.log(used_editor)
        }
        function resetFn(){
            $scope.isNotComposed = false
            $scope.question = ''
            $scope.used_editor_html = ''
        }
        $scope.resetQuestion = function (){
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('This will remove question from the input, If you want to edit use editor')
                .ariaLabel('Lucky day')
                .ok('Remove')
                .cancel('Dont delete');

            $mdDialog.show(confirm).then(function() {
                resetFn()
            }, function(f, r) {
            });
        }
    }
}
class editorLACtrl {
    constructor($scope, $mdDialog, parentScope) {
        Simditor.locale = 'en-US';
        var editor = undefined
        angular.element(document).ready(function () {
            $scope.editor = {}
            editor = new Simditor({
                textarea: $('#editor'),
                placeholder: '',
                params: {},
                upload: false,
                tabIndent: true,
                toolbar: [
                    'title',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'fontScale',
                    'color',
                    'ol' ,      
                    'ul'  ,          
                    'blockquote',
                    'code',         
                    'table',
                    'link',
                    // 'image',
                    'hr',           
                    'indent',
                    'outdent',
                    'alignment'
                ],
                toolbarFloat: true,
                toolbarFloatOffset: 0,
                toolbarHidden: false,
                pasteImage: false,
                cleanPaste: false,
                codeLanguages : [{ name: 'Erlang', value: 'erlang' },]
                //optional options
            });
            if(parentScope.question){
                console.log(parentScope)
                if(!parentScope.isLatex){
                    editor.setValue(parentScope.question)
                }
            }
        });
        $scope.saveContent = (desc) => {
            console.log(desc)
            console.log($scope.editor)
            let editor_value = editor.getValue()
            if(!editor_value){
                toastr.error("Please enter question")
                return false
            }
            parentScope.setQuestionFromEditor(editor_value)
            $mdDialog.hide();
        }
        $scope.closeEditor = () => {
            $mdDialog.hide();
        }
    }
}
export default LongController;



// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/longController.js